module.exports = __webpack_public_path__ + "img/pic2.fa2eb352.png";